<div class="options mt-3" [ngClass]="{ '!pl-0 !pt-0': tagData.callFrom === 'child', 'modal-main': tagData.callFrom !== 'dashboard' }">
  <!-- tags search list in chip form -->
  <mat-chip-listbox *ngIf="selectedTagsList?.length && (tagData.callFrom === 'sharing' || tagData.callFrom === 'dialog' || tagData.callFrom === 'dashboard')">
    <p *ngIf="tagData.callFrom === 'dashboard'" class="w-full font-bold text-sm ml-2" i18n>Selected tags</p>
    <mat-chip [highlighted]="true" class="mat-chipss" *ngFor="let tags of selectedTagsList; let i = index">
      <ng-container *ngIf="editingSelectedTag === tags._id; else notCurrentTag">
        <span *ngIf="!toggleEditSelectedTag">{{ tags.name }} ({{ tags.assetsCount }})</span>
        <div *ngIf="toggleEditSelectedTag" class="form-field-wrapper" (keydown.enter)="saveTagName(tags._id)" (keydown.escape)="exitRenameTag()">
          <input
            #renameSearchInput
            matInput
            type="text"
            thehubzTagsChipAutoWidth
            [(ngModel)]="tagName"
            (click)="$event.stopImmediatePropagation()"
            (keydown.arrowleft)="$event.stopImmediatePropagation()"
            (keydown.arrowright)="$event.stopImmediatePropagation()"
            (keydown.backspace)="$event.stopPropagation()"
            (keydown.delete)="$event.stopPropagation()"
          />
          <div class="form-field-actions">
            <button *ngIf="tagName" matSuffix mat-icon-button class="save-button icon-button-slim" aria-label="Save" i18n-matTooltip matTooltip="Save tag" (click)="saveTagName(tags._id)">
              <mat-icon class="material-icons-outlined">save</mat-icon>
            </button>
            <button matSuffix mat-icon-button aria-label="Clear" class="icon-button-slim" i18n-matTooltip matTooltip="Close edit tag" (click)="exitRenameTag()">
              <mat-icon class="material-icons-outlined">close</mat-icon>
            </button>
          </div>
        </div>
      </ng-container>
      <ng-template #notCurrentTag>
        <span>{{ tags.name }} </span><span *ngIf="tags.assetsCount"> ({{ tags.assetsCount }})</span>
      </ng-template>
      <ng-container *thehubzCanRole="{ role: ['tagging'], accessType: 'AnyAsset' }">
        <button
          *ngIf="!toggleEditSelectedTag || editingSelectedTag !== tags._id"
          matChipRemove
          mat-icon-button
          i18n-matTooltip
          matTooltip="Edit tag"
          class="menu-button icon-button-slim !pr-0"
          (click)="renameSelectedTag(i); $event.stopImmediatePropagation()"
        >
          <mat-icon class="material-icons-outlined">edit</mat-icon>
        </button>
      </ng-container>
      <button
        matChipRemove
        mat-icon-button
        i18n-matTooltip
        matTooltip="Remove tag"
        class="menu-button icon-button-slim !pl-0"
        (click)="removeSelectedTags(tags.name); $event.stopImmediatePropagation()"
      >
        <mat-icon class="material-icons-outlined">close</mat-icon>
      </button>
    </mat-chip>
  </mat-chip-listbox>
  <!-- Divider between search tags and tags list -->
  <mat-divider *ngIf="selectedTagsList?.length && (tagData.callFrom === 'dialog' || tagData.callFrom === 'sharing')" class="!my-1"></mat-divider>
  <!-- Show loader before loading the tags list from API -->
  <sp-loading-inprogress *ngIf="httpCallInProgress; else loadingComplete" [showSpinner]="true"></sp-loading-inprogress>
  <ng-template #loadingComplete>
    <!-- tags list in chip form -->
    <mat-chip-listbox>
      <p *ngIf="tagData.callFrom === 'dashboard'" class="w-full font-bold text-sm ml-2 mt-4" i18n>Tags suggestions</p>
      <mat-chip [removable]="true" class="mat-chipss" *ngFor="let tags of tagsObs | async; let i = index" (click)="addSelectedTags(tags)">
        <ng-container *ngIf="editingTag === tags._id; else notCurrentTag">
          <span *ngIf="!toggleEditTag">{{ tags.name }} ({{ tags.assetsCount }})</span>
          <div *ngIf="toggleEditTag" class="form-field-wrapper" (keydown.enter)="saveTagName(tags._id)" (keydown.escape)="exitRenameTag()">
            <input
              #renameInput
              matInput
              type="text"
              [(ngModel)]="tagName"
              thehubzTagsChipAutoWidth
              (click)="$event.stopImmediatePropagation()"
              (keydown.arrowleft)="$event.stopImmediatePropagation()"
              (keydown.arrowright)="$event.stopImmediatePropagation()"
              (keydown.backspace)="$event.stopPropagation()"
              (keydown.delete)="$event.stopPropagation()"
            />
            <div class="form-field-actions">
              <button
                *ngIf="tagName"
                matSuffix
                mat-icon-button
                class="save-button icon-button-slim"
                aria-label="Save"
                i18n-matTooltip
                matTooltip="Save tag"
                (click)="saveTagName(tags._id); $event.stopImmediatePropagation()"
              >
                <mat-icon class="material-icons-outlined">save</mat-icon>
              </button>
              <button matSuffix mat-icon-button aria-label="Clear" class="icon-button-slim" i18n-matTooltip matTooltip="Close edit tag" (click)="exitRenameTag(); $event.stopImmediatePropagation()">
                <mat-icon class="material-icons-outlined">close</mat-icon>
              </button>
            </div>
          </div>
        </ng-container>
        <ng-template #notCurrentTag>
          <span>{{ tags.name }} </span>&nbsp;<span *ngIf="tags.assetsCount"> ({{ tags.assetsCount }})</span>
        </ng-template>
        <!-- Edit tags -->
        <ng-container *thehubzCanRole="{ role: ['tagging'], accessType: 'AnyAsset' }">
          <button *ngIf="!toggleEditTag || editingTag !== tags._id" matChipRemove mat-icon-button i18n-matTooltip matTooltip="Edit tag" class="menu-button icon-button-slim" (click)="renameTag(i)">
            <mat-icon class="material-icons-outlined">edit</mat-icon>
          </button>
        </ng-container>
      </mat-chip>
    </mat-chip-listbox>
  </ng-template>
</div>
